import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_down_blue_bold",
  "use": "icon-icon_arrow_down_blue_bold-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon_arrow_down_blue_bold\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"m8.655 10.778 2.464-3.52A.8.8 0 0 0 10.463 6H5.537a.8.8 0 0 0-.656 1.259l2.464 3.519a.8.8 0 0 0 1.31 0Z\" fill=\"#2E5BFD\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol